module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.modifyLocation($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_1') ? _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('google-places-search', {
    attrs: {
      "passedValue": _vm.editingLocation.location_name,
      "confirmationMessage": _vm.confirmationMessage,
      "currentSelectedLocation": _vm.editingLocation.selected_location
    },
    on: {
      "selectedLocation": _vm.selectedLocationUpdated
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('google-maps-pin-confirmation', {
    attrs: {
      "passedValue": _vm.editingLocation.selected_location
    },
    on: {
      "updateLocationLatLng": _vm.locationLatLngUpdated
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), (_vm.process !== 'step_1') ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_1') ? _c('button', {
    key: "create-location-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_2', 'step_1')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('button', {
    key: "create-location-confirm",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
    attrs: {
      "steps": _vm.steps,
      "process": _vm.process
    }
  })], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tEdit Location Address\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f73dfbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyBusiness/Locations/EditLocationAddress.vue
// module id = 413
// module chunks = 1